// extracted by mini-css-extract-plugin
export default {"formUser":"FormUser_formUser__08PsL","formUserContainer":"FormUser_formUserContainer__xxK1J"};